import { getLTV } from '@hex/calculators-shared/utils';
import { FormDataType } from '../../types';

export function parseFormData(formData?: FormDataType) {
  if (!formData) {
    return {
      ltv: undefined,
      propertyValue: undefined,
      loanAmount: undefined,
      secondaryApplicantExist: undefined,
      primaryApplicantIncome: undefined,
      secondaryApplicantIncome: undefined,
    };
  }

  return {
    ltv: getLTV(formData.propertyValue, formData.loanAmount),
    propertyValue: parseInt(formData.propertyValue),
    loanAmount: parseInt(formData.loanAmount),
    secondaryApplicantExist: formData.secondaryApplicantExist === '1',
    primaryApplicantIncome: formData.primaryApplicantIncome ? parseInt(formData.primaryApplicantIncome) : undefined,
    secondaryApplicantIncome:
      formData.secondaryApplicantIncome && formData.secondaryApplicantExist === '1'
        ? parseInt(formData.secondaryApplicantIncome)
        : undefined,
  };
}
